import { useLocation, useNavigate } from 'react-router-dom';
import PullVaultLogoLight from '../../../assets/system/pull-vault-logo-light.png';
import { LogoLink, NavLink, NavLinks, NavUnderline, PageNavBar } from './PageNav.styles.js';

const LINKS = [
    ['Home', '/'],
    ['MLB The Show', '/mlb-the-show'],
    ['Card Cropper', '/card-cropper'],
];

const UNDERLINE_VARIANTS = {
    rest: { opacity: 0, scaleX: 0, y: 0 },
    hover: { opacity: 1, scaleX: 1, y: 3 },
};

export function NavButton({ active = false, children, ...props }) {
    const state = active ? 'hover' : 'rest';
    return (
        <NavLink
            type="button"
            $active={active}
            initial={state}
            animate={state}
            whileHover="hover"
            whileFocus="hover"
            {...props}
        >
            {children}
            <NavUnderline
                variants={UNDERLINE_VARIANTS}
                transition={{ duration: 0.3, ease: 'easeOut' }}
            />
        </NavLink>
    );
}

export default function PageNav() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <PageNavBar>
            <LogoLink type="button" onClick={() => navigate('/')} aria-label="Pull Vault home">
                <img src={PullVaultLogoLight} alt="Pull Vault" />
            </LogoLink>
            <NavLinks aria-label="Pages">
                {LINKS.map(([label, path]) => {
                    const active = path === '/' ? pathname === '/' : pathname.startsWith(path);
                    return (
                        <NavButton
                            key={path}
                            active={active}
                            aria-current={active ? 'page' : undefined}
                            onClick={() => navigate(path)}
                        >
                            {label}
                        </NavButton>
                    );
                })}
            </NavLinks>
        </PageNavBar>
    );
}
